import { useIntl } from '@edx/frontend-platform/i18n';
import StaticPageLayout from './StaticPageLayout';
import { getFaqPageContent } from './content';

const FaqPage = () => {
  const intl = useIntl();

  return <StaticPageLayout {...getFaqPageContent(intl)} sectionsVariant="accordion" />;
};

export default FaqPage;
